import React, { forwardRef } from 'react';
import { AssetUrls } from 'config/assets';
import { CHECKOUT_SOURCES } from './constants';
import { FINAL_CTA_COPY } from './copy';
import './sections.css';
import './FinalCta.css';

const BNG_47_SCRYFALL_ID = '546dae51-070c-4f3f-b0b4-6b88ff314af1';

interface FinalCtaProps {
  /** The per-month price label the compare card shows for the chosen interval. */
  perMonth: string;
  /** The note under the button for the chosen interval. */
  onSubscribe: (source: string) => void;
  note: string;
  isCheckoutLoading: boolean;
}

/**
 * FinalCta (Asana 1219949663037427, Decision 10; legibility per Asana
 * 1219988885932257, Decisions 7 and 8). The badge is a plain img sized by its
 * own attributes and CSS, not the fixed-size EliteBadge. The ref drives the
 * sticky bar's hide.
 */
const FinalCta = forwardRef<HTMLElement, FinalCtaProps>(({ perMonth, note, onSubscribe, isCheckoutLoading }, ref) => (
  <section ref={ref} className="elite-section elite-section--last final-cta" data-testid="final-cta">
    <div
      className="final-cta__panel"
      style={{ backgroundImage: `url(${AssetUrls.cards.getCardImage(BNG_47_SCRYFALL_ID, 'art_crop')})` }}
    >
      <div className="final-cta__overlay">
        <img
          src={AssetUrls.icons.elite.badge}
          alt=""
          width={72}
          height={72}
          className="final-cta__badge"
          data-testid="final-cta-badge"
        />
        <h2 className="final-cta__headline">{FINAL_CTA_COPY.headline}</h2>
        <p className="final-cta__body" data-testid="final-cta-body">
          {FINAL_CTA_COPY.body}
        </p>
        <button
          type="button"
          className="elite-subscribe-button elite-subscribe-button--shimmer final-cta__button"
          onClick={() => onSubscribe(CHECKOUT_SOURCES.bottom)}
          disabled={isCheckoutLoading}
        >
          {isCheckoutLoading ? 'Loading...' : `Subscribe Now · ${perMonth}/mo`}
        </button>
        <p className="final-cta__note">{note}</p>
      </div>
    </div>
  </section>
));

FinalCta.displayName = 'FinalCta';

export default FinalCta;
